/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>门店银行卡列表</public-title>
    <div class="load-area">
      <gcon-search @getSearchCon="getSearchCon" />
      <p v-if="StoreLists.total<=0">当前没有数据</p>
      <div v-else>
        <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="Itemize in StoreLists.lists" :key="Itemize.id">
          <li class="w-50 list-item-col list-item-title">
            <span class="text-link" @click="goStoreDetail(Itemize.store_id)">{{Itemize.title}}</span>
          </li>
          <li class="w-50 list-item-col">{{Itemize.bankcard_nums}}</li>
          <li class="w-50 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
            {{Itemize.verify | formatVar('verifyType')}}
          </li>
          <li class="w-50 list-item-col">
            {{Itemize.province_name}}-{{Itemize.city_name}}
          </li>
          <li class="w-50 list-item-col-end">
            <span class="text-link" @click="goForDetail(Itemize)">查看</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="StoreLists.total" :current-page="Number(queryCon.page)"
                       @current-change="v => this.$router.push({name:this.$route.name,query:{page:v}})"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapState, mapActions } from 'vuex'
  import GconSearch from '../GconSearch'
  export default {
    name: 'GroupBankcardList',
    components: { GconSearch },
    computed: {
      ...mapState(['StoreLists']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query }
    },
    watch:{
      queryCon() { this.groupGetStoreLists({ page:this.queryCon.page, type:3, ...this.info })  },
    },
    data() {
      return {
        titleArr:['门店名称','银行卡数量','门店认证','所在地','操作'],
        info: {}
      }
    },
    created() {
      if (this.queryCon.hasOwnProperty('page')) this.groupGetStoreLists({ page:this.queryCon.page, type:3 })
      else this.groupGetStoreLists({ page:1, type:3 })
    },
    methods:{
      ...mapActions(['groupGetStoreLists']),
      //查看门店银行卡列表
      goForDetail(item) {
        if (!this.$GFUN.powerIsInArray([240,166,285,382])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:this.$route.name,query:{...this.$route.query,store:item.store_id,GST:item.title}})
      },
      //查看门店详情页
      goStoreDetail(id) {
        let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:this.storeInfo.type,id,none:1}});

        window.open(routeUrl.href, '_blank');
      },
      getSearchCon (info) {
        this.info=info;
        this.groupGetStoreLists({ page:1, type:3, ...info })
      }
    }
  }
</script>
